var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotifExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29171 3.33398C7.29171 2.98881 7.01189 2.70898 6.66671 2.70898H3.33337C2.9882 2.70898 2.70837 2.98881 2.70837 3.33398V6.66732C2.70837 7.0125 2.9882 7.29232 3.33337 7.29232C3.67855 7.29232 3.95837 7.0125 3.95837 6.66732V4.84287L7.0581 7.94259C7.30218 8.18667 7.6979 8.18667 7.94198 7.94259C8.18606 7.69851 8.18606 7.30279 7.94198 7.05871L4.84226 3.95898H6.66671C7.01189 3.95898 7.29171 3.67916 7.29171 3.33398Z",
    fill: "#656579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7084 3.33398C12.7084 2.98881 12.9882 2.70898 13.3334 2.70898H16.6667C17.0119 2.70898 17.2917 2.98881 17.2917 3.33398V6.66732C17.2917 7.0125 17.0119 7.29232 16.6667 7.29232C16.3215 7.29232 16.0417 7.0125 16.0417 6.66732V4.84287L12.942 7.94259C12.6979 8.18667 12.3022 8.18667 12.0581 7.94259C11.814 7.69851 11.814 7.30279 12.0581 7.05871L15.1578 3.95898H13.3334C12.9882 3.95898 12.7084 3.67916 12.7084 3.33398Z",
    fill: "#656579"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29171 16.6673C7.29171 17.0125 7.01189 17.2923 6.66671 17.2923H3.33337C2.9882 17.2923 2.70837 17.0125 2.70837 16.6673V13.334C2.70837 12.9888 2.9882 12.709 3.33337 12.709C3.67855 12.709 3.95837 12.9888 3.95837 13.334V15.1584L7.0581 12.0587C7.30218 11.8146 7.6979 11.8146 7.94198 12.0587C8.18606 12.3028 8.18606 12.6985 7.94198 12.9426L4.84226 16.0423H6.66671C7.01189 16.0423 7.29171 16.3221 7.29171 16.6673Z",
    fill: "#656579"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7084 16.6673C12.7084 17.0125 12.9882 17.2923 13.3334 17.2923H16.6667C17.0119 17.2923 17.2917 17.0125 17.2917 16.6673V13.334C17.2917 12.9888 17.0119 12.709 16.6667 12.709C16.3215 12.709 16.0417 12.9888 16.0417 13.334V15.1584L12.942 12.0587C12.6979 11.8146 12.3022 11.8146 12.0581 12.0587C11.814 12.3028 11.814 12.6985 12.0581 12.9426L15.1578 16.0423H13.3334C12.9882 16.0423 12.7084 16.3221 12.7084 16.6673Z",
    fill: "#656579"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotifExpand);
export default __webpack_public_path__ + "static/media/motif-expand.06c39a9b6a39ab69a3a07c6e2afd9fa4.svg";
export { ForwardRef as ReactComponent };